import authenticatedAxiosInstance from './authenticatedAxiosInstance.service';
import authHeader from './auth-header';
import { LoanExceptionLog } from '../types/Loans.type';

const API_URL = process.env.REACT_APP_API_URL + '/loans';

/**
 *     app.get('/api/loans/billing-payment-log',
 *         [authJwt.verifyToken],
 *         controller.getBillingPaymentLog
 *     );
 *
 *     app.get('/api/loans/close-full-term-loans',
 *         [authJwt.verifyToken],
 *         controller.getCloseFullTermLoans
 *     );
 *
 *     app.get('/api/loans/docusign-status',
 *         [authJwt.verifyToken],
 *         controller.getDocuSignStatus
 *     );
 *
 *     app.get('/api/loans/funding-log',
 *         [authJwt.verifyToken],
 *         controller.getFundingLog
 *     );
 *
 *     app.get('/api/loans/loan-calculator',
 *         [authJwt.verifyToken],
 *         controller.getLoanCalculator
 *     );
 *
 *     app.get('/api/loans/loan-plan-payoff-requests',
 *         [authJwt.verifyToken],
 *         controller.getLoanPlanPayoffRequests
 *     );
 *
 *     app.get('/api/loans/matchup-exceptions',
 *         [authJwt.verifyToken],
 *         controller.getMatchupExceptions
 *     );
 *
 *     app.get("/api/loans/matchup-summary",
 *         [authJwt.verifyToken],
 *         controller.getLoansToLeaseMatchupSummary
 *     );
 *
 *     app.get("/api/loans/matchup-summary-detail-grid",
 *         [authJwt.verifyToken],
 *         controller.getLoansToLeaseMatchupDetailGrid
 *     );
 *
 *     app.get('/api/loans/move-loans-to-loanplan',
 *         [authJwt.verifyToken],
 *         controller.getMoveLoansToFloorplan
 *     );
 *
 *     app.get('/api/loans/paid-off-loans',
 *         [authJwt.verifyToken],
 *         controller.getPaidOffLoans
 *     );
 *
 *     app.get('/api/loans/pending-repo-swaps',
 *         [authJwt.verifyToken],
 *         controller.getPendingRepoSwaps
 *     );
 */

const routes = {
  ACTIVE_LOANS: `${API_URL}/active-loans`,
  BULK_PAYOFF_ACTIVE_VEHICLES: `${API_URL}/bulk-payoff-active-vehicles`,
  ACTIVE_LOAN: `${API_URL}/active-loan`,
  LOAN_STATUS: `${API_URL}/loan-status`,
  D_TITLE_STATUSES: `${API_URL}/d-title-statuses`,
  AMORTIZATIONS_BY_LOAN_ID: `${API_URL}/amortizations-by-loan-id`,
  SCAN_DOCS_BY_LOAN_ID: `${API_URL}/scan-docs-by-loan-id`,
  DOC_SIGNS: `${API_URL}/doc-signs`,
  REPO_SWAPS: `${API_URL}/repo-swaps`,
  PRINT_DOC: `${API_URL}/print-doc`,
  REVERSE_LOAN_PAYOFF: `${API_URL}/reverse-loan-payoff`,
  BILLING_PAYMENT_LOG: `${API_URL}/billing-payment-log`,
  BILLING_PAYMENT_LOG_DETAIL: `${API_URL}/billing-payment-log-detail`,
  CLOSE_FULL_TERM_LOANS: `${API_URL}/close-full-term-loans`,
  DOCUSIGN_STATUS: `${API_URL}/docusign-status`,
  FUNDING_LOG: `${API_URL}/funding-log`,
  FUNDING_LOG_DETAIL: `${API_URL}/funding-log-detail`,
  LOAN_CALCULATOR: `${API_URL}/loan-calculator`,
  LOAN_PLAN_PAYOFF_REQUESTS: `${API_URL}/loan-plan-payoff-requests`,
  PAYOFF_CALCULATOR: `${API_URL}/payoff-calculator`,
  CALC_PAYOFF: `${API_URL}/calc-payoff`,
  CALCULATE_PAYMENT: `${API_URL}/calculate-payment`,
  LOAN_SUMMARY_BY_DEALER: `${API_URL}/loan-summary-by-dealer`,
  LOAN_SUMMARY: `${API_URL}/loan-summary`,
  COMPANIES_WITH_LOANS: `${API_URL}/companies-with-loans`,
  LOAN_PENDING_FUNDING: `${API_URL}/loan-pending-funding`,
  LOAN_CANCEL_REQUESTS: `${API_URL}/loan-cancel-requests`,
  FUND_LOANS: `${API_URL}/fund-loans`,
  SUBMIT_ALL_DOCS_TO_DOCU_SIGN: `${API_URL}/submit-all-docs-to-docu-sign`,
  SUBMIT_DOCU_SIGN_PROM_DOCS: `${API_URL}/submit-docu-sign-prom-docs`,
  LOAN_PENDING_FUNDING_LOANS: `${API_URL}/loan-pending-funding-loans`,
  MATCHUP_EXCEPTIONS: `${API_URL}/matchup-exceptions`,
  EXCEPTION_LOGS: `${API_URL}/exception-logs`,
  MATCHUP_EXCEPTIONS_PRINT: `${API_URL}/matchup-exceptions/print`,
  MATCHUP_EXCEPTIONS_RELEASE: `${API_URL}/matchup-exceptions/release`,
  MATCHUP_EXCEPTIONS_DETAIL: `${API_URL}/matchup-exceptions-detail`,
  MATCHUP_EXCEPTION: `${API_URL}/matchup-exceptions/:recid`,
  MATCHUP_EXCEPTION_DEALER: `${API_URL}/matchup-exceptions/:recid/dealer`,
  PENDING_LOAN_WAIVE_FEE: `${API_URL}/pending/:id/waive-fee`,
  PENDING_LOAN_AUDITED: `${API_URL}/pending/:id/audited`,
  MATCHUP_EXCEPTIONS_NOTIFY_LHPH: `${API_URL}/matchup-exceptions/notify-lhph`,
  MATCHUP_STATUS: `${API_URL}/matchup-status`,
  LOAN_MATCH_STATUS: `${API_URL}/loan-match-status`,
  MATCHUP_SUMMARY: `${API_URL}/matchup-summary`,
  MATCHUP_SUMMARY_DETAIL_GRID: `${API_URL}/matchup-summary-detail-grid`,
  FREEZE_DATA: `${API_URL}/freeze-data`,
  MOVE_LOANS_TO_FLOORPLAN: `${API_URL}/move-loans-to-floorplan`,
  PAID_OFF_LOANS: `${API_URL}/paid-off-loans`,
  PENDING_REPO_SWAPS: `${API_URL}/pending-repo-swaps`,
  PENDING_REPO_SWAPS_FOR_APPROVAL: `${API_URL}/pending-repo-swaps-for-approval`,
  LOAN_LEASE_GRAPH_1: `${API_URL}/loan-lease-graph1`,
  LOAN_LEASE_GRAPH_2: `${API_URL}/loan-lease-graph2`,
  EXCEPTIONS_HISTORY: `${API_URL}/exceptions-history`,
  EXCEPTIONS_HISTORY_SEARCH: `${API_URL}/exceptions-history/search`,
  EXCEPTION_CODES: `${API_URL}/exception-codes`,
  CREDIT_LINE_PROJECTED_BILLING: `${API_URL}/credit-line-projected-billing`,
  FLOORPLAN_PROJECTED_BILLING: `${API_URL}/floorplan-projected-billing`,
  DEALER_DASHBOARD: `${API_URL}/dealer-dashboard`,
  DEALER_MONTHLY_UNITS: `${API_URL}/dealer-monthly-units`,
  DEALER_YOY_UNITS: `${API_URL}/dealer-yoy-units`,
  TITLE_AGEING: `${API_URL}/title-ageing`,
  LOAN_TO_LEASE_MATCHUP_SUMMARY: `${API_URL}/loan-to-lease-matchup-summary`,
  INVSL2: `${API_URL}/invsls2`,
  MORE_DEALER_STATS: `${API_URL}/more-dealer-stats`,
  BILLING_DATA: `${API_URL}/billing-data`,
  REFRESH_BB: `${API_URL}/refresh-bb`,
  BILLING_PAYMENT_LOG_PRINT: `${API_URL}/billing-payment-log/print`,
  BILL_LP: `${API_URL}/bill-lp`,
  EST_BILL_LP: `${API_URL}/est-bill-lp`,
  PAYOFF_LOANS: `${API_URL}/payoff-loans`,
  PAYOFF_REQUESTS: `${API_URL}/payoff-requests`,
  PAYOFF_FULL_TERM_LOANS: `${API_URL}/payoff-full-term-loans`,
  APPROVE_REPO_SWAPS: `${API_URL}/approve-repo-swaps`,
  APPROVE_SWAPS_ON_NEW_PLAN: `${API_URL}/approve-swaps-on-new-plan`,
  REFI_SWAP_APPROVAL: `${API_URL}/refi-swap-approval`,
  PREMIER_CONVERSION_APPROVAL: `${API_URL}/premier-conversion-approval`,
  SWAP_FROM_FP: `${API_URL}/swap-from-fp`,
  MOVE_TO_FLOORPLAN: `${API_URL}/move-to-floorplan`,
  CANCEL_SWAP_REQUESTS: `${API_URL}/cancel-swap-requests`,
  CANCEL_LOANS: `${API_URL}/cancel-loans`,
  REFRESH_PAID_DATES: `${API_URL}/refresh-paid-dates`,
  LOAN_MASTER: `${API_URL}/loan-master`,
  PULL_FROM_SOLUTIONS: `${API_URL}/pull-from-solutions`,
  PULL_REPO_SWAPS_FROM_SOLUTIONS: `${API_URL}/pull-repo-swaps-from-solutions`,
  REFRESH_SOLUTIONS_DOCS: `${API_URL}/refresh-solutions-docs`,
  REFRESH_SOLUTIONS_DOCS_BY_LOAN_ID: `${API_URL}/refresh-solutions-docs-by-loan-id`,
  UPLOAD_SCAN_DOC: `${API_URL}/upload-scan-doc`,
};

class LoansService {
  getActiveLoans(CompId?: string, searchText?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.ACTIVE_LOANS, {
      headers: authHeader(),
      params: { CompId, searchText },
      signal,
    });
  }

  getBulkPayoffActiveVehicles(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.BULK_PAYOFF_ACTIVE_VEHICLES, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getActiveLoan(RecId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.ACTIVE_LOAN, {
      headers: authHeader(),
      params: { RecId },
      signal,
    });
  }

  updateActiveLoan(id: string, data: object) {
    return authenticatedAxiosInstance.put(`${routes.ACTIVE_LOAN}/${id}`, data, {
      headers: authHeader(),
    });
  }

  reverseLoanPayoff(id: string) {
    return authenticatedAxiosInstance.post(`${routes.REVERSE_LOAN_PAYOFF}/${id}`, {
      headers: authHeader(),
      params: { id },
    });
  }

  getLoanStatus(RecId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_STATUS, {
      headers: authHeader(),
      params: { RecId },
      signal,
    });
  }

  getDTitleStatuses(RecId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.D_TITLE_STATUSES, {
      headers: authHeader(),
      params: { RecId },
      signal,
    });
  }

  getAmortizationsByLoanId(LoanId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.AMORTIZATIONS_BY_LOAN_ID, {
      headers: authHeader(),
      params: { LoanId },
      signal,
    });
  }

  getScanDocsByLoanId(LoanId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.SCAN_DOCS_BY_LOAN_ID, {
      headers: authHeader(),
      params: { LoanId },
      signal,
    });
  }

  getDocSigns(RecId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.DOC_SIGNS, {
      headers: authHeader(),
      params: { RecId },
      signal,
    });
  }

  refreshSolutionsDocs(listData: any[]) {
    return authenticatedAxiosInstance.post(
      routes.REFRESH_SOLUTIONS_DOCS,
      { listData },
      { headers: authHeader() }
    );
  }

  refreshSolutionsDocsByLoanId(loanId: string | undefined) {
    return authenticatedAxiosInstance.post(
      routes.REFRESH_SOLUTIONS_DOCS_BY_LOAN_ID,
      { loanId },
      { headers: authHeader() }
    );
  }

  uploadScanDoc(
    description: string,
    compId: string,
    loanId: string,
    byUserName: string,
    file: File
  ) {
    const formData = new FormData();
    formData.append('description', description);
    formData.append('compId', compId.toString());
    formData.append('loanId', loanId.toString());
    formData.append('byUserName', byUserName);
    formData.append('file', file);

    return authenticatedAxiosInstance.post(routes.UPLOAD_SCAN_DOC, formData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getRepoSwaps(RecId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.REPO_SWAPS, {
      headers: authHeader(),
      params: { RecId },
      signal,
    });
  }

  printDoc(
    recId: string,
    compId: string,
    reportId: string,
    rate: string,
    planType: string,
    byUserName: string
  ) {
    return authenticatedAxiosInstance.post(routes.PRINT_DOC, {
      recId,
      compId,
      reportId,
      rate,
      planType,
      byUserName,
    });
  }

  getBillingPaymentLog(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.BILLING_PAYMENT_LOG, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  updateBillingPaymentLog(id: string, data: object) {
    return authenticatedAxiosInstance.put(`${routes.BILLING_PAYMENT_LOG}/${id}`, data, {
      headers: authHeader(),
    });
  }

  getBillingPaymentLogEntry(id: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(`${routes.BILLING_PAYMENT_LOG}/${id}`, {
      headers: authHeader(),
      signal,
    });
  }

  getBillingPaymentLogDetail(BillingLogId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.BILLING_PAYMENT_LOG_DETAIL, {
      headers: authHeader(),
      params: { BillingLogId },
      signal,
    });
  }

  getCloseFullTermLoans(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.CLOSE_FULL_TERM_LOANS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getDocuSignStatus(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.DOCUSIGN_STATUS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getFundingLogs(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.FUNDING_LOG, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getFundingLog(id: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.FUNDING_LOG + `/${id}`, {
      headers: authHeader(),
      signal,
    });
  }

  getFundingLogDetail(FundingLogId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.FUNDING_LOG_DETAIL, {
      headers: authHeader(),
      params: { FundingLogId },
      signal,
    });
  }

  getLoanCalculator(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_CALCULATOR, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getLoanLeaseGraph1(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_LEASE_GRAPH_1, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getLoanLeaseGraph2(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_LEASE_GRAPH_2, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getLoanPlanPayoffRequests(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_PLAN_PAYOFF_REQUESTS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getPayoffCalculator(CompId?: string, searchText?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.PAYOFF_CALCULATOR, {
      headers: authHeader(),
      params: { CompId, searchText },
      signal,
    });
  }

  calcPayoff(recId: string, payoffDate: string) {
    return authenticatedAxiosInstance.post(
      routes.CALC_PAYOFF,
      { recId, payoffDate },
      { headers: authHeader() }
    );
  }

  // What-if payment calculator. The math runs in the MySQL getpayment() function
  // (legacy-parity, no client-side float math) — see api getpayment.procedure.js.
  calculatePayment(
    params: {
      AmtFin: number;
      NumPmts: number;
      LoanDate: string;
      FirstDate: string;
      IntRate: number;
    },
    signal?: AbortSignal
  ) {
    return authenticatedAxiosInstance.post(routes.CALCULATE_PAYMENT, params, {
      headers: authHeader(),
      signal,
    });
  }

  getLoanSummaryByDealer(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_SUMMARY_BY_DEALER, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getLoanSummary(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_SUMMARY, {
      headers: authHeader(),
      signal,
      timeout: 60000,
    });
  }

  getCompaniesWithLoans(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.COMPANIES_WITH_LOANS, {
      headers: authHeader(),
      signal,
    });
  }

  getLoanPendingFundingLoans(CompId?: string, searchText?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_PENDING_FUNDING_LOANS, {
      headers: authHeader(),
      params: { CompId, searchText },
      signal,
    });
  }

  getLoanPendingFunding(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_PENDING_FUNDING, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getLoanCancelRequests(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_CANCEL_REQUESTS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  loanCancelRequests(listData: any[]) {
    return authenticatedAxiosInstance.post(
      routes.LOAN_CANCEL_REQUESTS,
      { listData },
      { headers: authHeader() }
    );
  }

  fundLoans(listData: any[], byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.FUND_LOANS,
      { listData, byUserName, compId },
      { headers: authHeader() }
    );
  }

  submitAllDocsToDocuSign(byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.SUBMIT_ALL_DOCS_TO_DOCU_SIGN,
      { byUserName, compId },
      { headers: authHeader() }
    );
  }

  submitDocuSignPromDocs(byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.SUBMIT_DOCU_SIGN_PROM_DOCS,
      { byUserName, compId },
      { headers: authHeader() }
    );
  }

  getMatchupSummary(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.MATCHUP_SUMMARY, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getMatchupSummaryDetailGrid(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.MATCHUP_SUMMARY_DETAIL_GRID, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  freezeData(compId: string, exceptionDate: string) {
    return authenticatedAxiosInstance.post(
      routes.FREEZE_DATA,
      { compId, exceptionDate },
      { headers: authHeader() }
    );
  }

  getMatchupExceptions(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.MATCHUP_EXCEPTIONS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getLoanMatchStatus(CompId?: string, searchText?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_MATCH_STATUS, {
      headers: authHeader(),
      params: { CompId, searchText },
      signal,
    });
  }

  matchupExceptionsPrint(
    recId: string,
    reportDate: string,
    reportId: string,
    outputType: string,
    userShortName: string
  ) {
    return authenticatedAxiosInstance.post(
      routes.MATCHUP_EXCEPTIONS_PRINT,
      { recId, reportDate, reportId, outputType, userShortName },
      { headers: authHeader() }
    );
  }

  releaseMatchupException(compId: string, reportDate: string) {
    return authenticatedAxiosInstance.post(
      routes.MATCHUP_EXCEPTIONS_RELEASE,
      { compId, reportDate },
      { headers: authHeader() }
    );
  }

  deleteMatchupException(recId: string, reportDate: string) {
    return authenticatedAxiosInstance.delete(routes.MATCHUP_EXCEPTIONS, {
      headers: authHeader(),
      data: { recId, reportDate },
    });
  }

  getLoanExceptionLogs(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.EXCEPTION_LOGS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  // lhphcapital-3nm5: staff save one change to a matchup exception row (legacy's grids).
  updateMatchupException(recid: string | number, values: Record<string, unknown>) {
    return authenticatedAxiosInstance.put(
      routes.MATCHUP_EXCEPTION.replace(':recid', String(recid)),
      values,
      { headers: authHeader() }
    );
  }

  // lhphcapital-3nm5: a dealer saves one answer on its own released matchup row.
  updateMatchupDealerResponse(recid: string | number, values: Record<string, unknown>) {
    return authenticatedAxiosInstance.put(
      routes.MATCHUP_EXCEPTION_DEALER.replace(':recid', String(recid)),
      values,
      { headers: authHeader() }
    );
  }

  // lhphcapital-2lx5: Pending Loans' Waive / Unwaive fee (staff only).
  setPendingLoanFeeWaiver(recId: string | number, waive: boolean) {
    return authenticatedAxiosInstance.put(
      routes.PENDING_LOAN_WAIVE_FEE.replace(':id', String(recId)),
      { waive },
      { headers: authHeader() }
    );
  }

  // lhphcapital-2lx5: Pending Loans' Audited tick (staff only).
  setPendingLoanAudited(recId: string | number, audited: boolean) {
    return authenticatedAxiosInstance.put(
      routes.PENDING_LOAN_AUDITED.replace(':id', String(recId)),
      { audited },
      { headers: authHeader() }
    );
  }

  // lhphcapital-3nm5: the dealer site's "Notify LHPH" button.
  notifyLhphMatchupException(compId: string, reportDate: string) {
    return authenticatedAxiosInstance.post(
      routes.MATCHUP_EXCEPTIONS_NOTIFY_LHPH,
      { compId, reportDate },
      { headers: authHeader() }
    );
  }

  getMatchupExceptionsDetail(
    MatchType: string,
    CompId?: string,
    ReportDate?: string,
    signal?: AbortSignal
  ) {
    return authenticatedAxiosInstance.get(routes.MATCHUP_EXCEPTIONS_DETAIL, {
      headers: authHeader(),
      params: { CompId, ReportDate, MatchType },
      signal,
    });
  }

  getMatchupStatus(vin: string, compId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.MATCHUP_STATUS, {
      headers: authHeader(),
      params: { vin, compId },
      signal,
    });
  }

  getExceptionCodes(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.EXCEPTION_CODES, {
      headers: authHeader(),
      signal,
    });
  }

  getExceptionsHistory(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.EXCEPTIONS_HISTORY, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getExceptionsHistorySearch(
    Approved: string,
    Completed: string,
    CompId?: string,
    signal?: AbortSignal
  ) {
    return authenticatedAxiosInstance.get(routes.EXCEPTIONS_HISTORY_SEARCH, {
      headers: authHeader(),
      params: {
        compId: CompId,
        approved: Approved,
        completed: Completed,
      },
      signal,
    });
  }

  createExceptionsHistory(data: LoanExceptionLog) {
    return authenticatedAxiosInstance.post(routes.EXCEPTIONS_HISTORY, data, {
      headers: authHeader(),
    });
  }

  updateExceptionsHistory(id: string, data: object) {
    return authenticatedAxiosInstance.put(`${routes.EXCEPTIONS_HISTORY}/${id}`, data, {
      headers: authHeader(),
    });
  }

  deleteExceptionsHistory(id: string) {
    return authenticatedAxiosInstance.delete(`${routes.EXCEPTIONS_HISTORY}/${id}`, {
      headers: authHeader(),
    });
  }

  getMoveLoansToFloorplan(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.MOVE_LOANS_TO_FLOORPLAN, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getPaidOffLoans(CompId?: string, searchText?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.PAID_OFF_LOANS, {
      headers: authHeader(),
      params: { CompId, searchText },
      signal,
    });
  }

  getPendingRepoSwaps(CompId?: string, searchText?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.PENDING_REPO_SWAPS, {
      headers: authHeader(),
      params: { CompId, searchText },
      signal,
    });
  }

  getPendingRepoSwapsForApproval(CompId?: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.PENDING_REPO_SWAPS_FOR_APPROVAL, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  getCreditLineProjectedBilling(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.CREDIT_LINE_PROJECTED_BILLING, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  // bead 1a65: these are sent as YYYY-MM-DD strings, not Dates. A Date serialises
  // into the query string as a full ISO date-time, which the API then has to
  // re-parse; the endpoint validates and rejects anything it cannot read, so the
  // caller sends the exact format the stored procedure wants.
  getFloorplanProjectedBilling(
    CompId: string,
    billdate: string,
    DueDate: string,
    signal?: AbortSignal
  ) {
    return authenticatedAxiosInstance.get(routes.FLOORPLAN_PROJECTED_BILLING, {
      headers: authHeader(),
      params: { CompId, billdate, DueDate },
      signal,
      timeout: 60000,
    });
  }

  getDealerDashboard(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.DEALER_DASHBOARD, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getDealerMonthlyUnits(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.DEALER_MONTHLY_UNITS, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getDealerYoyUnits(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.DEALER_YOY_UNITS, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getTitleAgeing(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.TITLE_AGEING, {
      headers: authHeader(),
      signal,
      timeout: 60000,
    });
  }

  getLoanToLeaseMatchupSummary(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.LOAN_TO_LEASE_MATCHUP_SUMMARY, {
      headers: authHeader(),
      params: { CompId },
      signal,
      timeout: 60000,
    });
  }

  getInvsl2(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.INVSL2, {
      headers: authHeader(),
      signal,
      timeout: 60000,
    });
  }

  getMoreDealerStats(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.MORE_DEALER_STATS, {
      headers: authHeader(),
      signal,
      timeout: 60000,
    });
  }

  refreshBB(compId: string | undefined) {
    return authenticatedAxiosInstance.post(
      routes.REFRESH_BB,
      { compId },
      { headers: authHeader() }
    );
  }

  billingPaymentLogPrint(recId: string, outputType: string, userShortName: string) {
    return authenticatedAxiosInstance.post(
      routes.BILLING_PAYMENT_LOG_PRINT,
      { recId, outputType, userShortName },
      { headers: authHeader() }
    );
  }

  getBillingData(
    isInitial: string,
    compId: string,
    billDate?: string,
    dueDate?: string,
    signal?: AbortSignal
  ) {
    return authenticatedAxiosInstance.get(routes.BILLING_DATA, {
      params: { isInitial, compId, billDate, dueDate },
      headers: authHeader(),
      signal,
    });
  }

  billLP(compId: string, invoiceDate: string, dueDate: string, userShortName: string) {
    return authenticatedAxiosInstance.post(
      routes.BILL_LP,
      { compId, invoiceDate, dueDate, userShortName },
      { headers: authHeader() }
    );
  }

  estBillLP(compId: string, invoiceDate: string, dueDate: string, userShortName: string) {
    return authenticatedAxiosInstance.post(
      routes.EST_BILL_LP,
      { compId, invoiceDate, dueDate, userShortName },
      { headers: authHeader() }
    );
  }

  /**
   * Get API endpoint documentation for debugging purposes
   * @returns {Promise} - API response with endpoint documentation
   */
  getApiDocumentation(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(`${API_URL}/docs`, { headers: authHeader(), signal });
  }

  /**
   * Get SQL procedure documentation for debugging purposes
   * @returns {Promise} - API response with SQL procedure documentation
   */
  getSqlDocumentation(signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(`${API_URL}/sql-docs`, { headers: authHeader(), signal });
  }

  payoffLoans(listData: any[], payoffDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.PAYOFF_LOANS,
      { listData, payoffDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  // A dealer ASKS for payoffs (sets PayoffReq); staff execute them with payoffLoans.
  // (lhphcapital-3su4)
  // payoffDate: YYYY-MM-DD, the date the dealer picks; the API saves that date's quote (3jv5).
  requestPayoffs(listData: { RecID: number }[], compId: string, payoffDate: string) {
    return authenticatedAxiosInstance.post(
      routes.PAYOFF_REQUESTS,
      { listData: listData.map(item => ({ RecID: item.RecID })), compId, payoffDate },
      { headers: authHeader() }
    );
  }

  payoffFullTermLoans(listData: any[], payoffDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.PAYOFF_FULL_TERM_LOANS,
      { listData, payoffDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  approveRepoSwaps(listData: any[], approvalDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.APPROVE_REPO_SWAPS,
      { listData, approvalDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  approveSwapsOnNewPlan(listData: any[], approvalDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.APPROVE_SWAPS_ON_NEW_PLAN,
      { listData, approvalDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  refiSwapApproval(listData: any[], approvalDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.REFI_SWAP_APPROVAL,
      { listData, approvalDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  premierConversionApproval(
    listData: any[],
    approvalDate: string,
    byUserName: string,
    compId: string
  ) {
    return authenticatedAxiosInstance.post(
      routes.PREMIER_CONVERSION_APPROVAL,
      { listData, approvalDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  swapFromFP(listData: any[], approvalDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.SWAP_FROM_FP,
      { listData, approvalDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  moveToFloorplan(vehicleList: any[], payoffDate: string, byUserName: string, compId: string) {
    return authenticatedAxiosInstance.post(
      routes.MOVE_TO_FLOORPLAN,
      { vehicleList, payoffDate, byUserName, compId },
      { headers: authHeader() }
    );
  }

  getCancelSwapRequests(CompId: string, signal?: AbortSignal) {
    return authenticatedAxiosInstance.get(routes.CANCEL_SWAP_REQUESTS, {
      headers: authHeader(),
      params: { CompId },
      signal,
    });
  }

  cancelLoans(listData: any[]) {
    return authenticatedAxiosInstance.post(
      routes.CANCEL_LOANS,
      { listData },
      { headers: authHeader() }
    );
  }

  refreshPaidDates(listData: any[]) {
    return authenticatedAxiosInstance.post(
      routes.REFRESH_PAID_DATES,
      { listData },
      { headers: authHeader() }
    );
  }

  createLoanMaster(data: any) {
    return authenticatedAxiosInstance.post(routes.LOAN_MASTER, data, { headers: authHeader() });
  }

  pullFromSolutions(compId: string, byUserName: string, startDate: string, endDate: string) {
    return authenticatedAxiosInstance.post(
      routes.PULL_FROM_SOLUTIONS,
      { compId, byUserName, startDate, endDate },
      { headers: authHeader() }
    );
  }

  /** Legacy's repo/swap Pull for a Solutions dealer, via DCS's API. Dates are YYYY-MM-DD. */
  pullRepoSwapsFromSolutions(compId: string, startDate: string, endDate: string) {
    return authenticatedAxiosInstance.post(
      routes.PULL_REPO_SWAPS_FROM_SOLUTIONS,
      { compId, startDate, endDate },
      { headers: authHeader() }
    );
  }
}

export default new LoansService();
